<div class="gw-flex gw-flex-col gw-gap-medium gw-max-w-[720px]">
  <section
    class="gw-rounded-xl gw-border-base gw-bg-background-elevation-3 gw-p-medium"
  >
    <h2 class="gw-m-0 gw-text-base gw-font-semibold gw-text-text-primary">
      {{ 'features.profile.notifications.title' | translate }}
    </h2>
    <p class="gw-m-0 gw-mt-2x-small gw-text-sm gw-text-text-secondary">
      {{ 'features.profile.notifications.description' | translate }}
    </p>

    <div *ngIf="loading" class="gw-mt-medium gw-flex gw-flex-col gw-gap-small">
      <gatewee-skeleton></gatewee-skeleton>
      <gatewee-skeleton></gatewee-skeleton>
      <gatewee-skeleton></gatewee-skeleton>
    </div>

    <p
      *ngIf="!loading && loadError"
      class="gw-mt-medium gw-m-0 gw-text-sm gw-text-status-warning"
      role="status"
    >
      {{ 'features.profile.notifications.loadFallback' | translate }}
    </p>

    <div *ngIf="!loading" class="gw-mt-medium gw-flex gw-flex-col gw-gap-small">
      <gatewee-checkbox
        [label]="'features.profile.notifications.channels.whatsapp' | translate"
        [(ngModel)]="settings.whatsapp"
        [disabled]="saving"
      ></gatewee-checkbox>
      <gatewee-checkbox
        [label]="'features.profile.notifications.channels.email' | translate"
        [(ngModel)]="settings.email"
        [disabled]="saving"
      ></gatewee-checkbox>
      <gatewee-checkbox
        [label]="'features.profile.notifications.channels.push' | translate"
        [(ngModel)]="settings.push"
        [disabled]="saving"
      ></gatewee-checkbox>
    </div>

    <div *ngIf="!loading" class="gw-mt-medium">
      <gatewee-button
        iconName="@tui.check"
        [title]="'features.profile.notifications.save' | translate"
        [loading]="saving"
        [disabled]="saving"
        (clicked)="save()"
      ></gatewee-button>
    </div>
  </section>
</div>
